import Swal from 'sweetalert2'
import wrapper from 'sweetalert2-react-content'

export default wrapper(Swal)